import React from 'react';
import { HStack, Text, Icon } from '@chakra-ui/react';
import { FiMessageCircle, FiHeadphones } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { ensureConversationExists, isPreAcceptance } from 'utils/collabUtils';
import { Campaign, Collab, Client } from '@foodfluence/shared';

interface HelpSectionProps {
  collab?: Collab;
  campaign?: Campaign;
  client?: Client;
}

const HelpSection: React.FC<HelpSectionProps> = ({ collab, campaign, client }) => {
  const navigate = useNavigate();

  const handleChatWithBrand = async () => {
    if (!collab?.id) return;
    // Pre-acceptance: never create the thread client-side (that fires the welcome early); the
    // first send creates it server-side.
    if (!isPreAcceptance(collab)) await ensureConversationExists(collab.id, collab.clientID);
    navigate(`/inbox/messages/${collab.id}`, { state: { conversationId: collab.id, campaign, collab, client } });
  };

  const handleSupport = () => {
    if (window.$crisp) {
      window.$crisp.push(['do', 'chat:show']);
      window.$crisp.push(['do', 'chat:open']);
    }
  };

  return (
    <HStack spacing="10px" fontFamily="display" justify="center">
      <HStack as="button" type="button" onClick={handleSupport}
        h="44px"
        px="16px"
        justify="center"
        spacing="6px"
        borderRadius="999px"
        border="1.5px solid #0E0E0E"
        bg="#FFFFFF"
        color="#0E0E0E"
        cursor="pointer"
        _hover={{ bg: '#F2F2F0' }}
      >
        <Icon as={FiHeadphones} boxSize="16px" />
        <Text as="span" fontSize="14px" fontWeight="600">Support</Text>
      </HStack>
      <HStack as="button" type="button" onClick={handleChatWithBrand}
        h="44px"
        px="16px"
        justify="center"
        spacing="6px"
        borderRadius="999px"
        border="1.5px solid #0E0E0E"
        bg="#0E0E0E"
        color="#C6F432"
        cursor="pointer"
        _hover={{ bg: '#2A2A2C' }}
      >
        <Icon as={FiMessageCircle} boxSize="16px" />
        <Text as="span" fontSize="14px" fontWeight="600">Message brand</Text>
      </HStack>
    </HStack>
  );
};

export default HelpSection; 